import { AppHelper } from "../appHelper";
import { Helper } from "../core/util/helper";
import { ComponentHelper } from "../core/util/componentHelper";
import { TextBox } from "../core/components/textBox";
import { FAIcon } from "../core/components/faIcon";
import { HTTPService, createHtppServiceInstance } from "../core/util/httpManager";
import { General } from "../../siteManagement/general";
import { EventType } from "../../siteManagement/eventManager";
import React from "react";

export default class ShowProtokollUebersicht extends React.Component<any, ServerLogState> {
    common = new AppHelper();
    private _icuh = Helper;
    private _translations = {};
    private _factory = ComponentHelper.createFactory();
    private _protocolUrl: string;
    private _stateUrl: string;
    private  _jobid: number;
    private _protid: number;
    private iconName = "";
    private _divDecription = "";
    private intervall: number;

    constructor(props) {
        super(props);
        this._translations = this.props.context.translations;
        this._jobid = this.props.entity.Jobid;
        this._protid = 0;
        this._divDecription = this._translations["WebSMS.DataExchangeModule.ExecuteTemplate.SoonExecute"];
        this.iconName = "hourglass-start fa-5x";
        this._protocolUrl = "ServerTemplate/GetProtocolEntries";
        this._stateUrl = "ServerTemplate/GetJobState";
        this.state = {
            Protokoll: "",
            Status: 0,
            ShowProtocol: false,
            onHover:false
        };     
        this.common.init(this);
    }
    private _gettextBoxProtokollProps = () => {
        const props = this._factory.getDefaultTextBoxProps();
        props.field.readOnly = true;
        props.value = this.state.Protokoll;
        props.field.triggerOnChange = true;
        props.field.model = "";
        props.field.multiLine = true;
        props.field.focus = true;
        return props;
    }
    private _getProtocolEntries=(params)=> {
        const qsp = {
            Jobid: (this._icuh.hasValue(params[0]) ? params[0] : 0),
            Protocolid: (this._icuh.hasValue(params[1]) ? params[1] : 0)
        };
        const serverjob = {
            Jobid: (this._icuh.hasValue(params[0]) ? params[0] : 0)         
        };
        const urlProt = this._protocolUrl + Helper.addQueryStringParameters("", qsp);
        const url = this._stateUrl + Helper.addQueryStringParameters("", serverjob);
        let protocoll = this.state.Protokoll;
        createHtppServiceInstance().noBusyIndicator().chainBatch
            .add(urlProt)
            .add(url)
            .promise()
            .then(result => {
                if (this._icuh.hasValue(result[0].Data)) {
                    if (result[0].Data.length > 0) {
                        const arrDescription = [];
                        for (let i = 0; i < result[0].Data.length; i++) {
                            arrDescription.push(result[0].Data[i].Description)
                        }
                        protocoll += arrDescription.join("\n"); 
                        this.setState({ ...this.state,Protokoll: protocoll});
                        if (this.state.ShowProtocol) {
                            var objDiv = document.getElementById("protUebersicht").firstElementChild;
                            objDiv.scrollTop = objDiv.scrollHeight;
                        }
                        this._protid = result[0].Data[result[0].Data.length - 1].Protocolid;
                    }
                }
                switch (result[1].Data) {
                    case 0: {
                        this.iconName = "hourglass-start";
                        this._divDecription = this._translations["WebSMS.DataExchangeModule.ExecuteTemplate.SoonExecute"];
                        this.setState({ ...this.state, Status: result[1], Protokoll: protocoll });
                        break;
                    }
                    case -1: {
                        this.iconName = "times";
                        this._divDecription = this._translations["WebSMS.DataExchangeModule.ExecuteTemplate.ErrorOccured"];
                        this.setState({ ...this.state, Status: result[1], Protokoll: protocoll });
                        break;
                    }
                    case 1: {
                        this.iconName = "exchange";
                        this._divDecription = this._translations["WebSMS.DataExchangeModule.ExecuteTemplate.JobStarted"];
                        this.setState({ ...this.state, Status: result[1], Protokoll: protocoll });
                        break;
                    }
                    case 2: {
                        this.iconName = "sync";
                        this._divDecription = this._translations["WebSMS.DataExchangeModule.ExecuteTemplate.StartExport"];
                        this.setState({ ...this.state, Status: result[1], Protokoll: protocoll });
                        break;

                    }
                    case 3: {
                        this.iconName = "check";
                        this._divDecription = this._translations["WebSMS.DataExchangeModule.ExecuteTemplate.ExportSuccessful"];
                        window.clearInterval(this.intervall);
                        General.Events.trigger(EventType.Custom, { command: "reloadSiteAfterExecute" });
                        this.setState({ ...this.state, Status: result[1], Protokoll: protocoll });
                        break;

                    }
                }
            });
    }
    componentDidMount() {
        this._getProtocolEntries([this._jobid, this._protid]);
        this.intervall= window.setInterval(this._getProtocolEntries, 10000, [this._jobid, this._protid]);
       
    }
    componentWillUnmount() {
        window.clearInterval(this.intervall);
    }
    private showProtocol = () => {
        this.setState({ ...this.state, ShowProtocol: !this.state.ShowProtocol });
    }
    onHover = () => {
        this.setState({ ...this.state,onHover: true });
    }

    onHoverLeft = () => {
        this.setState({ ...this.state,onHover: false });
    }
    render() {
        const linkStyle: React.CSSProperties = {
            fontSize: "large",
            marginTop: "10px",
            color: this.state.onHover ? "var( --primary-color)" : "#c9c9c9"
        }

        var attributes: string[] = ["5x"];
        if (this.iconName=="sync") {
            attributes.push("spin");
        } if (this.iconName == "check") {
            attributes = ["5x"];
        }
        let linkText = "";
        if (this.state.ShowProtocol) {
            linkText = this._translations["WebSMS.DataExchangeModule.ExecuteTemplate.Less"];
        } else {
            linkText = this._translations["WebSMS.DataExchangeModule.ExecuteTemplate.More"];
        }
        return (<>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <FAIcon name={this.iconName} sameWidth={true} style={{ color: ' var( --primary-color)' }} attributes={attributes} />
                <div style={{ marginTop: '20px', color: ' var( --primary-color)', fontSize: "medium"}}>{this._divDecription}</div>
                <a onClick={this.showProtocol} onMouseOver={this.onHover} onMouseLeave={this.onHoverLeft} style={linkStyle}>{linkText}</a>
                </div>
            {this.state.ShowProtocol ?
                <div style={{marginTop:'10px'}} id="protUebersicht">
                    <TextBox{...this._gettextBoxProtokollProps()} > </TextBox>
                </div>
                :null
            }
        </>);
    }

};
interface ServerLogState {
    Protokoll: string;
    Status: number;
    ShowProtocol: boolean;
    onHover: boolean;
}
